import React from 'react';
import './Logo.css';

const Logo: React.FC = () => {
  return (
    <div className="logo">
      <img 
        src="https://cdn.glistar.ai/loginpage/logo.png" 
        alt="Glistar" 
        className="logo-image"
      />
    </div>
  );
};

export default Logo;
